import React from "react";
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
class Search extends React.Component {

    render() {
        return (
           
                <Input
                    style={{ width: '100%' ,padding:'6px',paddingLeft:'24px',marginTop:'15px' ,boxSizing: 'border-box'}}
                    id="search" onKeyUp={(ev)=> this.props.handleSearch(ev.target.value)} placeholder={this.props.placeholder || 'Zoeken...'}
                    startAdornment={
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    }
                />
           
        );
    }
}
export default Search;


